import { formatTime, formatDate } from '../../filter'
import moment from 'moment'

// 约定的数据字段结构
/**
 * 获取编辑数据
 * @returns {
    key: string; // 字段名称
    label: string; // 字段显示名
    value: string; // 字段当前值。枚举值时用英文逗号分隔。已经设值和默认值都可通过当前字段实现。当字段类型为下拉列表等时，要映射到枚举值的展示值
    type: string; // 字段类型
    notNull: string; // 是否必填。0-非必填，1-必填
    enumCode: string; // enumCode":"对应枚举code。当type为下拉列表/选框时用
    length?: number; // 字段长度限制。当type为文本输入框时用
    maxValue?: number; // 最大值。type为数字时用
    minValue?: number; // 最小值。type为数字时用
    canEdit?: boolean; // 自定义的是否可编辑
    selectOption: any[]; // 自定义的下拉选项
    rules?: any[]; // 支持自定义校验规则
    spacialLabelWidth?: number; // 支持自定义label宽度
    symbol?: string; // 输入框后面的单位或符号
    button?: string; // 输入框后面的按钮
    btnFun?: Function; // 输入框后面的按钮
    labelSpan?: Function; // label的栅格比例
    wrapperSpan?: Function; // 内容的栅格比例
}
 */

export default function() {
	const res = this.checkParams()
	if (!res) {
		return
	}
	const { order, injured, setting } = this

	const injuredInfo = (injured && injured.injuredInfo) || {}
	let arr = []

	arr = arr.concat([
		{
			label: '实际就诊医院',
			value: injuredInfo.factVisitingHospital,
			key: 'factVisitingHospital',
			type: 'text',
			notNull: '0',
			canEdit: false,
		},
		{
			label: '实际就诊科室',
			value: injuredInfo.departmentCode,
			key: 'departmentCode',
			selectOption: setting.paicHospitalsubjectList,
			type: 'select',
			notNull: '1',
			canEdit: true,
		},
	])
	arr.push({
		label: '住院号',
		value: injuredInfo.inpatientNo,
		key: 'inpatientNo',
		type: 'text',
		notNull: '1',
		canEdit: true,
		rules: [
			{
				max: 30,
				message: '长度不能超过30位',
				trigger: 'blur',
			},
		],
	})
	arr.push({
		label: '床位号',
		value: injuredInfo.bedNo,
		key: 'bedNo',
		type: 'text',
		notNull: '1',
		canEdit: true,
		rules: [
			{
				max: 10,
				message: '长度不能超过10位',
				trigger: 'blur',
			},
		],
	})
	arr.push(
		{
			label: '首次治疗时间',
			value:
				injuredInfo.firstTreatmentTime &&
				moment(
					formatTime(injuredInfo.firstTreatmentTime),
					'YYYY-MM-DD HH:mm:ss'
				),
			key: 'firstTreatmentTime',
			type: 'datetime',
			notNull: '1',
			canEdit: true,
			allowClear: false,
			disabledDate: current => {
				// 不能大于今天
				return current && current > moment().endOf('day')
			}, //禁止选择的时间区间
		},
		{
			label: '治疗情况（一级）',
			value: injuredInfo.condition,
			selectOption: setting.curetypeList,
			key: 'condition',
			type: 'select',
			notNull: '1',
			canEdit: true,
		},
		{
			label: '治疗情况（二级）',
			value: injuredInfo.conditionDetail,
			selectOption: setting.accidentaffectList,
			key: 'conditionDetail',
			type: 'select',
			notNull: '1',
			canEdit: true,
		},
		{
			label: '伤者主诉',
			value: injuredInfo.injuredStatement,
			key: 'injuredStatement',
			type: 'text',
			notNull: '1',
			canEdit: true,
			rules: [
				{
					max: 200,
					message: '长度不能超过200位',
					trigger: 'blur',
				},
			],
		}
	)

	arr.push({
		label: '入院日期',
		value: injuredInfo.hospitalizedDate
			? moment(formatDate(injuredInfo.hospitalizedDate), 'YYYY-MM-DD')
			: '',
		key: 'hospitalizedDate',
		type: 'date',
		notNull: '1',
		canEdit: true,
		allowClear: false,
		disabledDate: current => {
			// 不能大于今天
			return current && current > moment().endOf('day')
		}, //禁止选择的时间区间
	})

	arr.push({
		label: '出院日期（未出院填写预估出院时间）',
		value: injuredInfo.leaveDate
			? moment(formatDate(injuredInfo.leaveDate), 'YYYY-MM-DD')
			: '',
		key: 'leaveDate',
		type: 'date',
		notNull: '1',
		canEdit: true,
		allowClear: false,
		labelSpan: 16,
		wrapperSpan: 8,
		disabledDate: current => {
			// 大于今天小于一年
			const lastYear = moment().add(1, 'y')
			return (
				current &&
				(current < moment().startOf('day') || current > lastYear.endOf('day'))
			)
		}, //禁止选择的时间区间
	})
	arr = arr.concat([
		{
			label: '已花费',
			value: injuredInfo.alreadySpent,
			symbol: '元',
			key: 'alreadySpent',
			type: 'text',
			notNull: '1',
			canEdit: true,
			rules: [
				{
					pattern: /^[1-9]\d{0,6}(\.\d{1,3})?$|^0(\.\d{1,3})?$/,
					message: '请输入8位数内正确金额格式',
					trigger: 'blur',
				},
			],
		},
		{
			label: '还需花费（预估）',
			value: injuredInfo.remainSpent,
			symbol: '元',
			key: 'remainSpent',
			type: 'text',
			notNull: '1',
			canEdit: true,
			labelSpan: 16,
			wrapperSpan: 8,
			rules: [
				{
					pattern: /^[1-9]\d{0,6}(\.\d{1,3})?$|^0(\.\d{1,3})?$/,
					message: '请输入8位数内正确金额格式',
					trigger: 'blur',
				},
			],
		},
	])

	arr.push({
		label: '是否需要垫付医疗费用',
		value: injuredInfo.advancePay,
		selectOption: setting.yesNoList,
		key: 'advancePay',
		type: 'select',
		notNull: '1',
		canEdit: true,
	})

	const obj = {
		title: '伤者伤情信息',
		key: 'injuredInfo', // 提交时对应的字段
		children: arr,
	}
	return obj
}
